import { createSelector } from 'reselect';
import { pathnameSelector } from 'shared/app/state/selectors/routes';

export const isAccountRewardsPathSelector = createSelector(
  pathnameSelector,
  (pathname) => pathname === '/account/rewards'
);

export const expiringStarsHashSelector = () => 'expiring-stars';
